const Entities = {
    "CARDINAL": {
        name: "Cardinal Value",
        bgColor: "#2268ac",
        textColor: "#F2F2F2",
        typeBgColor: "#053b71",
        typeTextColor: "#F2F2F2"
    },
    "DATE": {
        name: "Date Value",
        bgColor: "#FAE8FF",
        textColor: "#86198F",
        typeBgColor: "#D946EF",
        typeTextColor: "#FAE8FF"
    },
    "EVENT": {
        name: "Event Name",
        bgColor: "#FFEDD5",
        textColor: "#9A3412",
        typeBgColor: "#F97316",
        typeTextColor: "#FFEDD5"
    },
    "FAC": {
        name: "Building Name",
        bgColor: "#FFEDD5",
        textColor: "#9A3412",
        typeBgColor: "#F97316",
        typeTextColor: "#FFEDD5"
    },
    "GPE": {
        name: "Geo-political Entity",
        bgColor: "#EDE9FE",
        textColor: "#5B21B6",
        typeBgColor: "#5B21B6",
        typeTextColor: "#EDE9FE"
    },
    "LANGUAGE": {
        name: "Language Name",
        bgColor: "#EDE9FE",
        textColor: "#5B21B6",
        typeBgColor: "#5B21B6",
        typeTextColor: "#EDE9FE"
    },
    "LAW": {
        name: "Law Name",
        bgColor: "#FCE7F3",
        textColor: "#9D174D",
        typeBgColor: "#EC4899",
        typeTextColor: "#FCE7F3"
    },
    "LOC": {
        name: "Location Name",
        bgColor: '#d64541',
        textColor: '#F2F2F2',
        typeBgColor: '#780c22',
        typeTextColor: '#F2F2F2'
    },
    "MONEY": {
        name: "Money Name",
        bgColor: "#CCFBF1",
        textColor: "#115E59",
        typeBgColor: "#14B8A6",
        typeTextColor: "#CCFBF1"
    },
    "NORP": {
        name: "Affiliation",
        bgColor: "#FCE7F3",
        textColor: "#9D174D",
        typeBgColor: "#EC4899",
        typeTextColor: "#FCE7F3"
    },
    "ORDINAL": {
        name: "Ordinal Value",
        bgColor: "#E0E7FF",
        textColor: "#3730A3",
        typeBgColor: "#6366F1",
        typeTextColor: "#E0E7FF"
    },
    "ORG": {
        name: "Organization Name",
        bgColor: "#CCFBF1",
        textColor: "#115E59",
        typeBgColor: "#14B8A6",
        typeTextColor: "#CCFBF1"
    },
    "PERCENT": {
        name: "Percent Value",
        bgColor: "#994242",
        textColor: "#F2F2F2",
        typeBgColor: "#553529",
        typeTextColor: "#F2F2F2"
    },
    "PERSON": {
        name: "Person Name",
        bgColor: "#d9b9cb",
        textColor: "#68062d",
        typeBgColor: "#d9438d",
        typeTextColor: "#F2F2F2"
    },
    "PRODUCT": {
        name: "Product Name",
        bgColor: "#CCFBF1",
        textColor: "#115E59",
        typeBgColor: "#14B8A6",
        typeTextColor: "#CCFBF1"
    },
    "QUANTITY": {
        name: "Quantity Value",
        bgColor: "#d9b9cb",
        textColor: "#68062d",
        typeBgColor: "#d9438d",
        typeTextColor: "#F2F2F2"
    },
    "TIME": {
        name: "Time Value",
        bgColor: "#CCFBF1",
        textColor: "#115E59",
        typeBgColor: "#14B8A6",
        typeTextColor: "#CCFBF1"
    },
    "WORK_OF_ART": {
        name: "Name Of Work Of Art",
        bgColor: "#FCE7F3",
        textColor: "#9D174D",
        typeBgColor: "#EC4899",
        typeTextColor: "#FCE7F3"
    }
};

export default Entities;


// WEBPACK FOOTER //
// ./src/components/model/NamedEntityRecognition/Entities.ts